module.exports = __webpack_public_path__ + "static/media/supply_chain_problem.8d1ba21c.png";